import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jeugeo',
  templateUrl: './jeugeo.component.html',
  styleUrls: ['./jeugeo.component.css']
})
export class JeugeoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

    
  }

}
